import axios from 'axios';

// Set default base URL for all axios requests
// Note: calls include /api/ prefix (e.g. /api/auth/login), so baseURL is origin only
const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
axios.defaults.baseURL = apiUrl.replace(/\/api$/, '');

// Add a request interceptor to include the auth token
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle 401 Unauthorized responses
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Handle unauthorized access (e.g., redirect to login)
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default axios;
